export class AccommodationWelfareDetails {
    AccommodationTypeId: number;
    Code: string;
    Description: string;
    IsSelected: boolean;
    Carers: Carer[];
    SelectedCarerId: number;
}


export class Carer {
    CarerId: number;
    Code: string;
    Description: string;
    GivenName: string;
    FamilyName: string;
}


export class AccommodationWelfareUpdateDetails {
    AccommodationTypeId: number;
    SelectedCarerId: number;
}
